<ng-container *ngIf="question">
    <h2 class="block-title">{{question.label}}</h2>
    <p class="paragraph-13">{{question.description}}</p>
</ng-container>
<ion-textarea rows="7"
              autocapitalize="on"
              spellcheck="true"
              [placeholder]="placeHolder"
              [(ngModel)]="value"></ion-textarea>

<ng-container *ngIf="question">
    <ion-button color="secondary" [disabled]="!value || value.length == 0" (click)="continue()">
        {{'thoughtRecord.assessment.continue' | translate}}
    </ion-button>
</ng-container>
